<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template  v-slot:right_view>
          <div  id='neTable' class='h100vh-140'>
            <div class="h-toolbarBg">
                <ejs-toolbar>
                    <e-items>
                        <!-- <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("MCS.add")' :click='refreshClick'></e-item> -->
                        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MCS.add")' :click='addClick'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("MCS.mod")' :click='modifyClk'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MCS.del")' :click='delClick'></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox :placeholder='$t("Topo.pleaseEnterNeName")' v-model='searchValue' @keydown.native.enter='search'></ejs-textbox>
                </div>
            </div>
            <div class='h100 width-100vw h-scroll'>
            <ejs-grid ref='grid' v-bind:dataSource='nedata' height='calc(100% - 0px)' allowReordering='true' allowResizing='true' allowExcelExport='true' allowTextWrap='true'>
                <e-columns>
                    <!-- <e-column type="checkbox" headerText='neid' width='50' textAlign='Center'></e-column> -->
                    <e-column field='name' :headerText='$t("Topo.neName")'  textAlign='Center'></e-column>
                    <e-column field='typeCode' :headerText='$t("Topo.neType")' width='150' textAlign='Center' :valueAccessor='neTypeFormatter'></e-column>
                    <e-column field='equipmentName' :headerText='$t("Topo.neDev")' width='150' textAlign='Center'></e-column>
                    <e-column field='equipmentIP' :headerText='$t("Topo.devIp")' width='150' textAlign='Center'></e-column>
                    <e-column field='equipmentPort' :headerText='$t("Topo.devPort")' width='150' textAlign='Center'></e-column>
                    <e-column field='physicalIP' :headerText='$t("Topo.physicalIP")' width='150' textAlign='Center'></e-column>
                    <e-column field='physicalPort' :headerText='$t("Topo.physicalPort")' width='150' textAlign='Center'></e-column>
                </e-columns>
            </ejs-grid>
             <ejs-pager ref='nepager' @click='getNeListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
             </div>
          </div>
          <CustomDialog ref='nedialog' :element='neDialog.element' :styles='neDialog.styles' :messages='neDialog.messages'>
            <template v-slot:dialog-content>
              <add-ne ref="addNeFFFF" @close='addCancel'></add-ne>
            </template>
          </CustomDialog>
          <CustomDialog ref='updateNedialog' :element='updateNedialog.element' :styles='updateNedialog.styles' :messages='updateNedialog.messages'>
            <template v-slot:dialog-content>
              <UpdateNe ref="updateneFFFF" @close='updateCancel'></UpdateNe>
            </template>
          </CustomDialog>
        </template>
    </BasicLayout>
</template>

<style >

</style>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import CustomDialog from '../../../components/common/CustomDialog';
import AddNe from '../../../components/topoconfig/AddNe';
import UpdateNe from '../../../components/topoconfig/UpdateNe';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'NeManage',
  components: {
    BasicLayout,
    CustomDialog,
    AddNe,
    UpdateNe
  },
  data() {
    return {
        left: {
            show: false,
            name: ''
        },
        middle: {
            show: false,
            name: ''
        },
        right: {
            show: true,
            crumb: this.$t('Topo.neCrumb')
        },
        nedata:[],
        nedata1:[],
        titleFlag:'',
        neDialog: {
            element: {
                title: this.$t('Topo.neAdd'),
                // target: '#app',
                isClose: true,
                refName: this.$t('Topo.neMange'),
                buttonGroup: [
                    { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
                    { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },       
                ]
            },
            styles: {
                width: '680px',
                height: '573px',
                visible: false,
                model: true
            },
            messages: {
                title: this.$t('Topo.neAdd'),
            },
        },
        updateNedialog: {
            element: {
                title:  this.$t('Topo.neModify'),
                // target: '#app',
                isClose: true,
                refName: this.$t('Topo.neMange'),
                buttonGroup: [
                    { click: this.updateCancel, buttonModel: { content: this.$t('Topo.cancel') } },
                    { click: this.updateSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },                  
                ]
            },
            styles: {
                width: '680px',
                height: '573px',
                visible: false,
                model: true
            },
            messages: {
                title:  this.$t('Topo.neModify')
            },
        },
        searchValue:'',
         neTypemap: new Map()
        .set(3,this.$t('Topo.neMME'))
        .set(4,this.$t('Topo.neHSS'))
        .set(5,this.$t('Topo.nePGW'))
        .set(6,this.$t('Topo.neSGW'))
        .set(7,this.$t('Topo.nePCRF'))
        .set(8,this.$t('Topo.neTCF'))
        .set(9,this.$t('Topo.neTMF'))
        .set(10,this.$t('Topo.nePDTGW'))
        .set(11,this.$t('Topo.neDBS'))
        .set(12,this.$t('Topo.neMC_CMS'))
        .set(13,this.$t('Topo.neMC_CF'))
        .set(14,this.$t('Topo.neMC_GMS'))
        .set(15,this.$t('Topo.neMC_IDMS'))
        .set(16,this.$t('Topo.neMC_PF'))
        .set(17,this.$t('Topo.neBM_SC'))
        .set(18,this.$t('Topo.neMBMS_GW'))
        .set(19,this.$t('Topo.neFRS'))
        .set(20,this.$t('Topo.neMC_TMF'))
        .set(21,this.$t('Topo.nePRES'))
        .set(23,this.$t('Topo.neP_HSS'))
        .set(24,this.$t('Topo.neMC_KMS'))
        .set(27,this.$t('Topo.neMCE'))
        .set(28,this.$t('Topo.nePCDR'))
        .set(31,this.$t('Topo.neDMS'))
        .set(34,this.$t('Topo.neMC_GMS_NODE'))
        .set(35,this.$t('Topo.neCU'))
        .set(36,this.$t('Topo.neDU'))
        .set(1000,this.$t('Topo.neeNodeB'))
        .set(1001,this.$t('Topo.neODBBU'))
        .set(1101,this.$t('Topo.neiBS_B')),

         neDevmap: new Map()
        .set('10001',this.$t('Topo.devEPC'))
        .set('10002',this.$t('Topo.devIMS'))
        .set('10003',this.$t('Topo.devMCS'))
        .set('10004',this.$t('Topo.deveNodeB'))
        .set('10005',this.$t('Topo.deveNodeBIOPS'))
        .set('10006',this.$t('Topo.deviBS'))
        .set('10007',this.$t('Topo.deviBSB'))
        .set('10008',this.$t('Topo.devODBBU')),

        page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      },
    };
  },
  mounted() {
      this.getNeListData();
  },
  methods: {
      addClick() {
        this.$refs.nedialog.show();
        this.$refs.addNeFFFF.bindValidate();
      },
      delClick() {
	      const neidVec = this.getCheckedVals(true);
	      console.log('neidVec',neidVec)
	      if (neidVec) {
		      let params = JSON.stringify(neidVec[0]);
		      this.$layer.confirm({
			        msg: this.$t('Topo.sureDel'),
			        btn1: { msg: this.$t('Topo.cancel') },
			        btn2: { msg: this.$t('Topo.confirm'),
			          func: this.delNe
			        }
		      });
	     }
      },
      delNe(){
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        const params = selectedRecords[0].id;
        const This = this;
        this.axios.get(`/lte/ems/topo/ne/deleteNe/${params}`).then((response)=>{
        if(response.data === undefined){
          return;
        }
        if( response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {          	
          	This.$refs.nepager.ej2Instances.currentPage = 1;
            This.getNeListData();
            EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
            return;
          } 
          else {
          	EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          }
        }
      });
     },

     getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const neid = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        neid.push(checkedData[i].id);
      }
      return neid.length === 0 ? false : neid;
    },

      getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelectOne')});
        return false;
      }
      return selectedRecords;
    },

      modifyClk() {
        var item = this.$refs.grid.getSelectedRecords();
        if(item.length === 1) {
            this.$refs.updateNedialog.show();
            this.$refs.updateneFFFF.initData(item[0]);
            this.$refs.updateneFFFF.bindValidate();
        }
        if(item.length === 0) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
          return;
        }
      },
      addSubmit() {
        this.$refs.addNeFFFF.outputs();
        this.getNeListData();
      },
      addCancel() {
        this.$refs.nedialog.clear();
        this.$refs.nedialog.close();
        this.$refs.addNeFFFF.initData();
        this.getNeListData();
      },
      updateSubmit() {
        this.$refs.updateneFFFF.outputs();
        this.getNeListData();
      },
      updateCancel() {
        this.$refs.updateNedialog.clear();
        this.$refs.updateNedialog.close();
        this.$refs.updateneFFFF.initData();
        this.getNeListData();
      },
      neTypeFormatter(field, nedata) {
        return this.neTypemap.get(nedata[field]);
      },
      neDevFormatter(field, nedata){
        return this.neDevmap.get(nedata[field]);
      },
      //模糊搜索
      search() {
        const This = this;
        This.page.pageNo = 1;
        const params ={
        	  pageNo: This.page.pageNo ,
	          pageSize: This.page.pageSize ,
	          name: This.searchValue
        };
        
        this.axios.post(`/lte/ems/topo/ne/nePage2`, params ).then(response => {
          	if(response.data === undefined){
	            return;
	        }
	        if(response.status === 200) {
		         if (response.data.errorCode === 'SUCCESS') {
	              This.nedata = response.data.resultVal.result;
	              This.page.totalCount = response.data.resultVal.totalCount;
	            } else {
	              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
	            }
	        }
        });
        
        /**
         if(This.searchValue !==''){   //模糊搜索时页面初始化
          	This.page.pageNo = 1;
        }
        else{
        	This.page.pageNo = This.$refs.nepager.ej2Instances.currentPage;
        }
        
        this.$axios.get(`/lte/ems/topo/ne/nePage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`)
        .then((response) => {
          if (response.data === undefined) {
            return;
          }
          if (response.status === 200) {
            if (response.data.errorCode === 'SUCCESS') {
              This.nedata = response.data.resultVal.result;
              This.page.totalCount = response.data.resultVal.totalCount;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          }
        });*/
      },
      getNeListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.nepager.ej2Instances.currentPage;
      this.$axios.get(`/lte/ems/topo/ne/nePage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`)
      .then((response) => {
        console.log('responseNe',response);
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            This.nedata = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },
  }
};
</script>
